import { gql } from '@apollo/client';

const QUERIES = {
  CREATE_NEQ_REQUEST: gql`
    mutation createNEQRequest($eircode: String!, $prequalId: Int!) {
      createNEQRequest(eircode: $eircode, prequalId: $prequalId)
    }
  `,
  GET_NEQ_RESPONSE: gql`
    query getNEQResult($prequalId: Int!) {
      getNEQResult(prequalId: $prequalId) {
        preOrderFlag
        pendingInstallation
        reserved
        surveyRequired
        interventionArea
        activeLines
        neqStatus
        multiplePremises
        lineId
        readyForServiceAt
        lines {
          name
          status
          ontActive
          lineId
          addressId
          reserved
          pendingInstallation
          activeLines
          canContinueSale
        }
      }
    }
  `,
};
const MUTATION = {
  SET_NBI_LINE: gql`
    mutation SetNBILine($prequalId: Int!, $lineDetails: LineDetails!) {
      setNBILine(prequalId: $prequalId, lineDetails: $lineDetails) {
        interventionArea
        surveyRequired
        multiplePremises
        preOrderFlag
        readyForServiceAt
        neqStatus
        lines {
          name
          status
          lineId
          addressId
          reserved
          pendingInstallation
          activeLines
        }
      }
    }
  `,
};
// to create NEQ Request for nbi Journey
export const createNEQRequest = async ({ graphql, variables = {} }) => {
  try {
    const { data, error } = await graphql.mutate({
      mutation: QUERIES.CREATE_NEQ_REQUEST,
      variables,
    });
    return { data: data?.createNEQRequest, error };
  } catch (error) {
    console.error(error);
    return { error };
  }
};
// to get NEQ Response for nbi Journey
export const getNEQResponse = async ({ graphql, variables = {} }) => {
  try {
    const { data, error } = await graphql.query({
      query: QUERIES.GET_NEQ_RESPONSE,
      variables,
    });
    return { data: data?.getNEQResult, status: data?.getNEQResult?.neqStatus, error };
  } catch (error) {
    console.error(error);
    return { error: error?.graphQLErrors };
  }
};
// to set NBI Line for UG
export const setNBILine = async ({ graphql, variables = {} }) => {
  try {
    const { data, error } = await graphql.mutate({
      mutation: MUTATION.SET_NBI_LINE,
      variables,
    });
    return { data: data?.setNBILine, status: data?.setNBILine?.neqStatus, error };
  } catch (error) {
    console.error(error);
    return { error: error?.graphQLErrors };
  }
};
